import React, { useState } from 'react';
import PropTypes from 'prop-types';
import { ClipLoader } from 'react-spinners';
import { tokenStore } from 'sharetribe-flex-sdk';
import { getResaleHubMagicLink } from '../../../../util/api';
import css from './SectionCustomHero.module.css';
import { LazyLoadImage } from 'react-lazy-load-image-component';

if (typeof window !== 'undefined') {
  require('react-lazy-load-image-component/src/effects/opacity.css');
}

// SectionCustomHeroOld -> GERRY WEBER Style (Full screen image on landing page with text overlay)

const SectionCustomHero = ({ sectionId, svgImage, svgImageLR, title, text, blocks }) => {
  const [isLoadingSellLink, setIsLoadingSellLink] = useState(false);

  const button1 = blocks[0].callToAction;
  const button2 = blocks[1].callToAction;

  const resaleHubSellButtonsEnabled =
    process.env.REACT_APP_RESALE_HUB_SELL_BUTTONS_ENABLED === 'true';

  const handleSellLinkClick = async e => {
    e.preventDefault();

    // Check if this is a sell button (assuming button2 is the sell button based on LandingPage.js)
    if (button2.href !== '/sell') {
      // If it's not a sell button, proceed with normal navigation
      window.location.href = button2.href;
      return;
    }

    // Check if user is authenticated by looking for token
    const cookieTokenStore = tokenStore.browserCookieStore({
      clientId: process.env.REACT_APP_SHARETRIBE_SDK_CLIENT_ID,
      secure: process.env.REACT_APP_SHARETRIBE_USING_SSL === 'true',
    });

    const token = cookieTokenStore.getToken();
    const isAuthenticated = !!token;

    if (!isAuthenticated) {
      window.location.href = '/login';
      return;
    }

    setIsLoadingSellLink(true);

    try {
      const response = await getResaleHubMagicLink();
      window.open(response.magicLink, '_blank', 'noopener,noreferrer');
    } catch (err) {
      console.error('SellLink error:', err);
    } finally {
      setIsLoadingSellLink(false);
    }
  };

  return (
    <div className={css['section-custom-hero-container']}>
      <div className={css['section-custom-hero']}>
        <LazyLoadImage
          alt="Hero"
          src={svgImage}
          placeholderSrc={svgImageLR}
          className={css['section-custom-hero-image']}
          effect="opacity"
          loading="eager"
          decoding="async"
          width="100%"
          threshold={100}
          height="auto"
          visibleByDefault={true}
        />
        <div className={css.darkOverlay}></div>
        <div className={css['overlay-content']}>
          <h1 className={css['overlay-title']}>{title}</h1>
          <p className={css['overlay-text']}>{text}</p>
          <div className={css['buttons-row']}>
            <a href={button1.href} target="_self">
              <button className={css['overlay-button']}>
                <span>→</span>
                {button1.content}
              </button>
            </a>
            {resaleHubSellButtonsEnabled && button2.href === '/sell' ? (
              <button
                onClick={handleSellLinkClick}
                className={css['overlay-button']}
                disabled={isLoadingSellLink}
              >
                <span>→</span>
                {button2.content}
                {isLoadingSellLink && (
                  <ClipLoader color="currentColor" size={10} className={css.loadingSpinner} />
                )}
              </button>
            ) : (
              <a href={button2.href} target="_self">
                <button className={css['overlay-button']}>
                  <span>→</span>
                  {button2.content}
                </button>
              </a>
            )}
          </div>
        </div>
      </div>
    </div>
  );
};

SectionCustomHero.propTypes = {
  sectionId: PropTypes.string.isRequired,
  title: PropTypes.string,
  text: PropTypes.string,
  svgImage: PropTypes.string.isRequired,
  svgImageLR: PropTypes.string.isRequired,
  blocks: PropTypes.arrayOf(
    PropTypes.shape({
      blockType: PropTypes.string.isRequired,
      blockId: PropTypes.string.isRequired,
      callToAction: PropTypes.shape({
        fieldType: PropTypes.string.isRequired,
        href: PropTypes.string.isRequired,
        content: PropTypes.string.isRequired,
      }).isRequired,
    })
  ).isRequired,
};

export default SectionCustomHero;
